import { User } from 'types/user';

import { measureStoredMessage, validateParticipationMessages } from './participation-messages';

export type SituacaoDoParticipante = 'sem-percentual' | 'sem-descricao' | 'completo';

/**
 * Situação de uma pessoa na lista de participantes (RCP-33). "Pendente" é tudo que não está `completo`: a régua é a
 * mesma que trava o "Continuar" (`validateParticipationMessages`), aplicada só a essa pessoa.
 */
export function situacaoDoParticipante(
  pessoa: User,
  percentual: unknown,
  limites: { min: number; max: number },
): SituacaoDoParticipante {
  if (!(Number(percentual) > 0)) return 'sem-percentual';

  const { valid } = validateParticipationMessages([pessoa], { [pessoa._id]: percentual }, limites);
  return valid ? 'completo' : 'sem-descricao';
}

/** Se a pessoa já tem descrição escrita. Conta o texto, não a marcação: o editor esvaziado guarda `<p></p>` (RCP-27). */
export function temDescricao(pessoa: User): boolean {
  return measureStoredMessage(pessoa.message).textLength > 0;
}

function semAcento(texto: unknown): string {
  return String(texto ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

/** Filtro "Filtrar participantes" (RCP-34): nome de guerra, nome ou chave, sem diferenciar maiúsculas nem acentos. */
export function combinaComFiltro(pessoa: User, termo: string): boolean {
  const procurado = semAcento(termo.trim());
  if (!procurado) return true;

  return [pessoa.extra?.nome_guerra, pessoa.name, pessoa._id].some(campo => semAcento(campo).includes(procurado));
}
